/** @jsx jsx */
import { Box, jsx } from 'theme-ui'
import useNotificationTopBar from '~/hooks/components/use-notification-top-bar'

const NotificationTopBar = () => {
  const { loaded, notification } = useNotificationTopBar()

  if (!notification) return null

  return (
    <Box bg="brandPrimary">
      <Box
        variant="text.callout2"
        sx={{
          opacity: loaded ? '1' : '0',
          '& p, & a': {
            alignItems: 'center',
            color: 'white',
            display: 'flex',
            justifyContent: 'center',
            minHeight: '40px',
            m: 0,
            width: '100%',
          },
          '& a': {
            textDecoration: 'none',
            '&:focus, &:hover': {
              textDecoration: 'underline',
            },
          },
        }}
        dangerouslySetInnerHTML={{
          __html: notification.description.childMarkdownRemark.html,
        }}
      />
    </Box>
  )
}

export default NotificationTopBar
